import { ZD_SERVICES_WIDGET_KEY } from 'src/config';
import type { Conf } from 'src/global';
import { isSalesArticle, waitCondition, waitZe } from 'src/util';

import articlePage from './article-page';
import loadSolvvy from './solvvy';
import transitionRedirect from './transition-redirect';
import loadWebWidget from './web-widget';
import loadZendeskSnippet from './zendesk-snippet';

const restoreLinks = () => {
    document.querySelectorAll<HTMLLinkElement>('.solvvy-support-flow-link').forEach(el => {
        el.style.display = 'none';
    });

    document.querySelectorAll<HTMLLinkElement>('.solvvy-replaced-link').forEach(el => {
        el.style.display = 'inline';
    });
};

export const loadHelpCenter = async (conf: Conf) => {
    transitionRedirect();

    if (location.pathname.includes('/requests')) {
        return;
    }

    if (location.pathname.includes('/articles/')) {
        articlePage();
    }

    if (conf.isPaidUser) {
        loadZendeskSnippet(ZD_SERVICES_WIDGET_KEY);
        await waitZe(loadWebWidget, conf);
        return;
    }

    // free user
    if (isSalesArticle(conf)) {
        loadZendeskSnippet(ZD_SERVICES_WIDGET_KEY);
        await waitZe(loadWebWidget, conf);
        window.zE?.hide();
    }

    loadSolvvy();

    if (location.pathname.includes('/articles/')) {
        waitCondition(
            () => !!document.getElementById('solvvy-container'),
            conf.waitError(`Wait Solvvy container timeout`),
        ).then(restoreLinks);
    }
};

export default loadHelpCenter;
